import { render, staticRenderFns } from "./VocationBannerSection.vue?vue&type=template&id=65f4d944"
import script from "./VocationBannerSection.vue?vue&type=script&lang=ts"
export * from "./VocationBannerSection.vue?vue&type=script&lang=ts"
import style0 from "./VocationBannerSection.vue?vue&type=style&index=0&id=65f4d944&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports